import { Navigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/authContext';



const RequireNotAuth = ({ children }: { children: React.ReactElement }) => {

  const [user, setUser] = useState(localStorage.getItem('user'));
  const { currentUser }: any = useContext(AuthContext);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setUser(localStorage.getItem('user'));

      if (user !== 'null') {
        
        clearInterval(intervalId);

        window.location.href='/'
      }
    }, 2000);

    return () => {
      clearInterval(intervalId); 
      
    };
  }, [user]); 

  if (currentUser) {
    if (currentUser.admin) return <Navigate to="/admin" />;
    else if (currentUser.name) return <Navigate to="/test" />;
  }

  return children;
};

export default RequireNotAuth;
